import { HTMLTable } from '@blueprintjs/core'
import styled from 'styled-components'

const GridTable = styled(HTMLTable)<{
  $minWidthsPx: number[]
}>`
  display: inline-table;
  width: 100%;
  min-width: ${(p) =>
    `${p.$minWidthsPx.reduce(
      (sum, minWidthPx) => sum + minWidthPx,
      0,
    )}px important!`};
  grid-template-columns: ${(p) =>
    p.$minWidthsPx
      .map((minWidthPx) => `minmax(${minWidthPx}px, 1fr)\n`)
      .join('')};

  thead,
  tbody,
  tr {
    // display: contents;
    cursor: pointer;
  }

  th {
    height: 120px;
    white-space: nowrap;
  }
  td,
  th {
    text-overflow: wrap;
    overflow-wrap: break-word;
  }
  td {
    padding: 6px;
    height: 60px;
  }
  .child-row td {
    grid-column: 1 / ${(p) => p.$minWidthsPx.length + 1};
  }
  .hide {
    display: none;
  }

  .header {
    width: 100%;
    height: 100%;
    text-align: left;
    position: relative;
    > div {
      width: 120px;
      position: absolute;
      bottom: 0;
      left: 15px;
      transform-origin: bottom left;
      transform: translate(-1ch, 1em) rotate(-45deg);
      button {
        span {
          line-height: 1em;
          max-height: 2em;
          max-width: 100%;
          text-overflow: ellipsis;
          word-break: break-word;
          margin-right: 0;
        }
      }
    }
  }
`
export default GridTable
